// extracted by mini-css-extract-plugin
export default {"factBoxLarge":"FactBoxLargeBlock_factBoxLarge__mJ0i9","heading":"FactBoxLargeBlock_heading__jIuO1","green":"FactBoxLargeBlock_green__uKRZ6","blue":"FactBoxLargeBlock_blue__hyLEr"};